export default "__VITE_ASSET__Bp4U82V6__"